/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Voices_Load_ErrorInputs */

const en_common_voices_load_error = /** @type {(inputs: Common_Voices_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load voice options. Please try later or contact support center.`)
};

const es_common_voices_load_error = /** @type {(inputs: Common_Voices_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las voces. Inténtalo más tarde o contacta soporte.`)
};

/**
* | output |
* | --- |
* | "Failed to load voice options. Please try later or contact support center." |
*
* @param {Common_Voices_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_voices_load_error = /** @type {((inputs?: Common_Voices_Load_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Voices_Load_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_voices_load_error(inputs)
	return en_common_voices_load_error(inputs)
});